/**
 * build-pc-analytics.js — CompuMe Build PC v2.0
 * Meta Pixel + Klaviyo + GTM events
 * Cart drawer badge injection
 */
'use strict';

// ============================================================
// TRACKING HELPER
// ============================================================
function bpTrack(eventName, data) {
  data = data || {};

  // ─ Meta Pixel ──────────────────────────────────────
  if (typeof fbq === 'function') {
    fbq('trackCustom', eventName, data);
    if (eventName === 'BP_AddToCart') {
      fbq('track', 'AddToCart', {
        value: data.total_jod || 0,
        currency: 'JOD',
        content_type: 'product_group',
        content_ids: data.variant_ids || [],
        num_items: data.num_items || 0
      });
    }
    if (eventName === 'BP_InitiateCheckout') {
      fbq('track', 'InitiateCheckout', {
        value: data.total_jod || 0,
        currency: 'JOD',
        num_items: data.num_items || 0
      });
    }
    if (eventName === 'BP_Stage_View') {
      fbq('track', 'ViewContent', {
        content_name: 'PC Builder Stage ' + data.stage,
        content_category: 'PC Builder'
      });
    }
  }

  // ─ Klaviyo ───────────────────────────────────────
  if (typeof klaviyo !== 'undefined' && klaviyo.push) {
    klaviyo.push(['track', eventName, data]);
  }

  // ─ GTM dataLayer ─────────────────────────────────
  if (window.dataLayer) {
    window.dataLayer.push(Object.assign({ event: 'bp_' + eventName.toLowerCase() }, data));
  }
}

// ============================================================
// HOOK INTO EXISTING BP FUNCTIONS
// ============================================================
document.addEventListener('DOMContentLoaded', function() {
  if (typeof BP === 'undefined') return;

  // ─ Stage 1 complete: "Show Me a Build"
  var _bpProceed = window.bpProceedToBlueprint;
  window.bpProceedToBlueprint = function() {
    bpTrack('BP_Build_Started', {
      use_case:   BP.useCase,
      budget_jod: BP.budget,
      resolution: BP.resolution
    });
    if (_bpProceed) _bpProceed();
  };

  // ─ Tier selected
  var _bpSelectTier = window.bpSelectTier;
  window.bpSelectTier = function(card) {
    var tierId = card ? card.dataset.tierId : '';
    bpTrack('BP_Tier_Selected', {
      tier_id:    tierId,
      budget_jod: BP.budget,
      use_case:   BP.useCase
    });
    if (_bpSelectTier) _bpSelectTier(card);
  };

  // ─ Component picked
  var _bpPickComponent = window.bpPickComponent;
  window.bpPickComponent = function(key, product, cardEl) {
    bpTrack('BP_Component_Selected', {
      category:  key,
      product:   product ? product.title : '',
      price_jod: product ? product.price : 0
    });
    if (_bpPickComponent) _bpPickComponent(key, product, cardEl);
  };

  // ─ Stage view
  var _bpGoToStage = window.bpGoToStage;
  window.bpGoToStage = function(n) {
    bpTrack('BP_Stage_View', { stage: n, use_case: BP.useCase, budget_jod: BP.budget });
    if (_bpGoToStage) _bpGoToStage(n);
  };

  // ─ Add to cart
  var _bpAddToCart = window.bpAddToCart;
  window.bpAddToCart = function() {
    var total    = Object.values(BP.build).reduce(function(s, v) { return s + (v ? (v.price || 0) : 0); }, 0);
    var varIds   = Object.values(BP.build).filter(function(v) { return v && v.variantId; }).map(function(v) { return v.variantId; });
    var discount = varIds.length >= 5 ? +(total * 0.03).toFixed(2) : 0;
    bpTrack('BP_AddToCart', {
      total_jod:   +(total - discount).toFixed(2),
      num_items:   varIds.length,
      variant_ids: varIds,
      discount_jod: discount,
      use_case:    BP.useCase,
      tier:        BP.tier ? BP.tier.id : null
    });
    if (_bpAddToCart) _bpAddToCart();
  };
});

// ============================================================
// CART DRAWER BADGE INJECTION
// Uses MutationObserver to catch drawer whenever it opens
// ============================================================
(function() {
  var BADGE_ID   = 'bp-drawer-badge';
  var PC_ATTR    = 'Build Type';
  var PC_VAL     = 'Custom PC Builder';
  var BADGE_HTML = `
    <div id="${BADGE_ID}" style="display:flex;align-items:center;gap:10px;padding:10px 16px;background:#f0fdf7;border-bottom:1px solid #bbf7d0;font-size:12px;color:#065f46;">
      <span style="font-size:1.1rem;">&#9733;</span>
      <span><strong>PC Builder Discount Active</strong> — 3% off your entire order at checkout.</span>
    </div>`;

  function injectBadge(drawerEl) {
    if (!drawerEl || drawerEl.querySelector('#' + BADGE_ID)) return;
    // Check if cart has PC Builder attribute via Shopify cart API
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var hasBuild = cart.attributes && cart.attributes[PC_ATTR] === PC_VAL;
        if (!hasBuild) return;
        var firstChild = drawerEl.querySelector('.drawer__inner, .cart-drawer__content, .mini-cart__content, [class*="cart"]');
        var target = firstChild || drawerEl.firstElementChild;
        if (target && !drawerEl.querySelector('#' + BADGE_ID)) {
          target.insertAdjacentHTML('afterbegin', BADGE_HTML);
        }
      })
      .catch(function() {});
  }

  // Watch for any element with drawer/cart classes being shown
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        if (/drawer|mini.?cart|side.?cart|cart.?popup/i.test(node.className || '')) {
          injectBadge(node);
        }
      });
      // Also check attribute changes (drawer opening via class toggle)
      if (m.type === 'attributes' && m.target) {
        var el = m.target;
        if (/drawer|mini.?cart|side.?cart/i.test(el.className || '')) {
          var isVisible = !el.hidden && el.offsetParent !== null;
          if (isVisible) injectBadge(el);
        }
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function() {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'hidden', 'aria-hidden', 'style']
    });

    // Also check on any cart icon click
    document.addEventListener('click', function(e) {
      var t = e.target.closest('[href*="/cart"], [data-cart], .cart-icon, .icon-cart, .mini-cart-icon, .js-mini-cart, .cart-trigger, .header__cart');
      if (t) {
        setTimeout(function() {
          var drawer = document.querySelector('.cart-drawer, .drawer--cart, .mini-cart, .side-cart, [class*="cart-drawer"], [id*="cart-drawer"], [id*="CartDrawer"]');
          if (drawer) injectBadge(drawer);
        }, 300);
      }
    });
  });
})();
